import { EditorialType } from '@news-mono/component-library'
import React, { FC } from 'react'
import { Classification } from './Classification'
import { Bullet } from './Bullet'
import { TopicLink } from './Topic'
import { Author, AuthorLink } from './Author'
import { TopicBylineWrapper } from './TopicBylineWrapper'
import CommentsCount from './CommentsCount'

export interface BylineProps {
    showClassification: boolean
    editorialType?: EditorialType
    topicLink: string
    topicTitle: string
    bylineText: string
    bylineLink?: string
    allowCommenting: boolean
    articleUrl: string
}

export const Byline: FC<BylineProps> = ({
    showClassification,
    editorialType,
    topicLink,
    topicTitle,
    bylineText,
    bylineLink,
    allowCommenting,
    articleUrl,
}) => {
    return (
        <TopicBylineWrapper>
            {editorialType && showClassification && (
                <>
                    <Classification type={editorialType}>
                        {editorialType}
                    </Classification>
                    <Bullet />
                </>
            )}
            <TopicLink to={topicLink}>{topicTitle}</TopicLink>
            {!!bylineText && (
                <>
                    <Bullet />
                    {!bylineLink ? (
                        <Author>{bylineText}</Author>
                    ) : (
                        <AuthorLink to={bylineLink}>{bylineText}</AuthorLink>
                    )}
                </>
            )}
            {allowCommenting && (
                <>
                    <Bullet />
                    <CommentsCount articleUrl={articleUrl} />
                </>
            )}
        </TopicBylineWrapper>
    )
}
